module.exports = __webpack_public_path__ + "epilace_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/epilace_1_before.jpg
// module id = 944
// module chunks = 0